import ForHireSummaryRow from "@/features/dashboards/components/ForHire/ForHireSummaryRow.tsx"
import SummaryRow from "@/features/dashboards/components/SummaryRow.tsx"
import summaryConfig from "@/features/dashboards/config/config.ts"
import forHireConfig from "@/features/dashboards/config/forHireConfig.ts"

export default function Home() {
  const locations = [2, 4, 5] // BCO, PLTH, LWRN
  const forHireLocations = [1]

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4 items-start">
      {locations.map((l) => (
        <SummaryRow location={l} config={summaryConfig.get(l)} key={l} />
      ))}
      {forHireLocations.map((l) => (
        <ForHireSummaryRow config={forHireConfig.get(l)} key={l} />
      ))}
    </div>
  )
}
